import { Model } from "infrontjs";

export class Template extends Model
{
    static schema = {
        id: { type: 'string', default: null  },
        userId: { type: 'string', default: null },
        name: { type: 'string', default: null  },
        description: { type: 'string', default: null },
        filename: { type: 'string', default: null },
        status: { type: 'string', enum: ['ACTIVE', 'INACTIVE'], default: 'INACTIVE' },
        createdAt: { type: 'datetime', default: null },
        updatedAt: { type: 'datetime', default: null },
        data: { type: 'object', default: null },
        organisationId: { type: 'string', default: null }
    };
}
